export default {"src":"/_next/static/image/public/images/other_report.e3d102439751f2016427d994ab0430d8.svg","height":24,"width":19};